import { useQuery } from '@apollo/client'
import type { SignInQueryResult } from '@/apollo/AuthRoute'
import { IS_LOGGED_IN } from '@/apollo/queries'

/** Apollo's local signed-in flag, the same one AuthRoute reads. */
export const useIsSignedIn = () => {
  const { data } = useQuery<SignInQueryResult>(IS_LOGGED_IN)
  return Boolean(data?.isLoggedIn)
}
